import { createSlice } from '@reduxjs/toolkit';
import { pmProjectsAction } from './pmProjects.actions';
import { fmProjectsAction } from '../../financeManagement/fmProjects/fmProjects.actions';

interface PMProjectsState {
  loading: boolean;
  success: any;
  error: any;
  assignedProjects: any;
  projectInvoicesList: any;
  projectInvoiceDetails: any;
  releaseProjectInvoiceData: any;
  projectCameraHash: string,
  projectCameraList: any,
  projectOverviewData: any;
  projectTimelineList: any;
  updateTaskConnections: any;
  projectPhaseTasksList: any;
  projectOverviewTaskData: any;
  projectPhases: any;
  projectOverviewAddTask: any;
  projectOverviewUpdateTask: any;
  projectOverviewDeleteTask: any;
  projectChangeOrderList: any;
  projectChangeOrderItems: any;
  createChangeOrder: any,
  changeOrderDetails: any,
  changeOrderTerms: any,
  savedChangeOrderNotes: any,
  changeOrderAttachmentList: any,
  changeOrderUploadSuccess: boolean,
  changeOrderRemoveSuccess: boolean,
  changeOrderRelease: boolean,
  changeOrderDelete: any,
  changeOrderDuplicate: any,
  coPaymentSchedule: any,
  rfpList: any,
  globalRfqAttachments: any,
  projectRfqsList: any;
  rfqsDetails: any,
  
  acceptedRfqBidsList: any,
  poList: any;
  poDetails: any;
  poReview: any;
  poPaymentSchedule: any;
  savedPOPaymentSchedule: any;

  projectExpensesList: any,
  expensesPaymentReview: any,
  expenseNotes: any,

  projectAutocomplete: any,

}
const initialState: PMProjectsState = {
  loading: false,
  success: null,
  error: null,
  assignedProjects: [],
  projectInvoicesList: [],
  projectInvoiceDetails: null,
  releaseProjectInvoiceData: null,
  projectCameraHash: "",
  projectCameraList: [],
  projectOverviewData: null,
  projectTimelineList: [],
  updateTaskConnections: null,
  projectPhaseTasksList: [],
  projectOverviewTaskData: null,
  projectPhases: [],
  projectOverviewAddTask: null,
  projectOverviewUpdateTask: null,
  projectOverviewDeleteTask: null,
  projectChangeOrderList: [],
  projectChangeOrderItems: [],
  createChangeOrder: null,
  changeOrderDetails: null,
  changeOrderTerms: null,
  savedChangeOrderNotes: null,
  changeOrderAttachmentList: null,
  changeOrderUploadSuccess: false,
  changeOrderRemoveSuccess: false,
  changeOrderRelease: false,
  changeOrderDelete: null,
  changeOrderDuplicate: null,
  coPaymentSchedule: [],
  rfpList: null,

  projectRfqsList: [],
  rfqsDetails: null,
  poList: [],
  poDetails: null,
  poPaymentSchedule: null,
  poReview: null,
  savedPOPaymentSchedule: null,

  acceptedRfqBidsList: [],

  projectExpensesList: [],
  expensesPaymentReview: [],
  expenseNotes: [],
  globalRfqAttachments: [],

  projectAutocomplete: [],
};

const pmProjectsSlice = createSlice({
  name: "pmProjectsSlice",
  initialState,
  reducers: {
    cleanChangeOrder: (state) => {
      state.createChangeOrder = [];
    },
    cleanCameraList: (state) => {
      state.projectCameraList = [];
    },
    setProjectTimelineList: (state, action) => {
      state.projectTimelineList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // -------- cases of project manager assigned projects list api data -------
      .addCase(pmProjectsAction.getProjectsListAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.assignedProjects = [];
      })
      .addCase(pmProjectsAction.getProjectsListAction.fulfilled, (state, action) => {
            state.loading = false;
            if(action?.payload?.data?.status===200){
              state.error = null;
              state.success = action?.payload?.data?.message;
              state.assignedProjects = action?.payload?.data?.data;
            }else{
              state.success = null;
              state.assignedProjects = [];
              state.error = 'Projects list could not be fetched.';
            }
      })
      .addCase(pmProjectsAction.getProjectsListAction.rejected, (state, action:any) => {
            state.loading = false;
            state.success = null;
            state.assignedProjects = [];
            state.error = action?.payload?.data?.message ?? 'Projects list could not be fetched.';
      })

      // -------- cases of project center invoices list api data -------
      .addCase(pmProjectsAction.getProjectInvoicesListAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.projectInvoicesList = [];
      })
      .addCase(pmProjectsAction.getProjectInvoicesListAction.fulfilled, (state, action) => {
            state.loading = false;
            if(action?.payload?.data?.status===200){
              state.error = null;
              state.success = action?.payload?.data?.message;
              state.projectInvoicesList = action?.payload?.data?.data;
            }else{
              state.success = null;
              state.projectInvoicesList = [];
              state.error = 'Projects invoices could not be fetched.';
            }
      })
      .addCase(pmProjectsAction.getProjectInvoicesListAction.rejected, (state, action:any) => {
            state.loading = false;
            state.success = null;
            state.projectInvoicesList = [];
            state.error = action?.payload?.data?.message ?? 'Projects invoices could not be fetched.';
      })

      // -------- cases of project center invoice details api data -------
      .addCase(pmProjectsAction.getProjectInvoiceDetailsAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.projectInvoiceDetails = null;
      })
      .addCase(pmProjectsAction.getProjectInvoiceDetailsAction.fulfilled, (state, action) => {
        state.loading = false;
        if(action?.payload?.data?.status===200){
          state.error = null;
          state.success = action?.payload?.data?.message;
          state.projectInvoiceDetails = action?.payload?.data?.data;
        }else{
          state.success = null;
          state.projectInvoiceDetails = null;
          state.error = 'Projects invoice details could not be fetched.';
        }
      })
      .addCase(pmProjectsAction.getProjectInvoiceDetailsAction.rejected, (state, action:any) => {
        state.loading = false;
        state.success = null;
        state.projectInvoiceDetails = null;
        state.error = action?.payload?.data?.message ?? 'Projects invoice details could not be fetched.';
      })

      // -------- cases of project center invoice release api data -------
      .addCase(pmProjectsAction.releaseInvoicesAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.releaseProjectInvoiceData = null;
      })
      .addCase(pmProjectsAction.releaseInvoicesAction.fulfilled, (state, action) => {
        state.loading = false;
        if(action?.payload?.data?.status===200){
          state.error = null;
          state.success = action?.payload?.data?.message;
          state.releaseProjectInvoiceData = action?.payload?.data?.data;
        }else{
          state.success = null;
          state.releaseProjectInvoiceData = null;
          state.error = 'Projects invoice could not be released.';
        }
      })
      .addCase(pmProjectsAction.releaseInvoicesAction.rejected, (state, action:any) => {
        state.loading = false;
        state.success = null;
        state.releaseProjectInvoiceData = null;
        state.error = action?.payload?.data?.message ?? 'Projects invoice could not be released.';
      })

      // -------- cases of projects camera hash api data -------
      .addCase(pmProjectsAction.getProjectCameraAction.pending, (state, action) => {
        state.error = "";
        // state.projectCameraList = [];
        state.projectCameraHash = "";
        state.loading = true;
      })
      .addCase(pmProjectsAction.getProjectCameraAction.fulfilled, (state, action) => {
        if(action?.payload?.data?.status === 200) {
          // state.projectCameraList = action.payload.data.data;
          state.projectCameraHash = action.payload.data.data?.feedHash;
          // localStorage.setItem("projectCameraHash", action.payload.data.data?.feedHash);
          state.error = "";
        } else {
          // state.projectCameraList = [];
          state.projectCameraHash = "";
          state.error = "Unable to fetch project camera list";
        }
      })
      .addCase(pmProjectsAction.getProjectCameraAction.rejected, (state, action:any) => {
        state.loading = false;
        // state.projectCameraList = [];
        state.projectCameraHash = "";
        state.error = action?.payload?.data?.message || "Unable to fetch project camera list";
      })

      // -------- cases of projects camera urls api data -------
      .addCase(pmProjectsAction.getProjectCameraFeedsAction.pending, (state, action) => {
        state.error = "";
        if(action?.meta?.arg?.reset){
          state.projectCameraList = [];
        }
        state.loading = true;
      })
      .addCase(pmProjectsAction.getProjectCameraFeedsAction.fulfilled, (state, action) => {
        if(action?.payload?.data?.status === 200) {
          state.projectCameraList = action.payload.data.data;
          state.error = "";
        } else {
          state.projectCameraList = [];
          state.error = "Unable to fetch project camera list";
        }
        state.loading = false;
      })
      .addCase(pmProjectsAction.getProjectCameraFeedsAction.rejected, (state, action:any) => {
        state.loading = false;
        state.projectCameraList = [];
        state.error = action?.payload?.data?.message || "Unable to fetch project camera list";
      })

      // -------- cases of project overview details api data -------
      .addCase(pmProjectsAction.getProjectOverviewDetailsAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        // set this as null only when user is not fetching this data while updating project tasks
        if(!action?.meta?.arg?.hideLoader){
          state.projectOverviewData = null;
        }
      })
      .addCase(pmProjectsAction.getProjectOverviewDetailsAction.fulfilled, (state, action) => {
            state.loading = false;
            if(action?.payload?.data?.status===200){
              state.error = null;
              state.success = action?.payload?.data?.message;
              state.projectOverviewData = action?.payload?.data?.data;

              const allOption = {
                  id: "all",
                  name: "All",
              }

              if(action?.meta?.arg?.filters?.assignedTo===undefined){
                // set user list as selected assignedTo array
                state.projectOverviewData = {
                  ...state.projectOverviewData,
                  filters: {
                    assignedTo: [allOption, ...action?.payload?.data?.data?.assignedUsers]
                  },
                  assignedUsers: [allOption, ...action?.payload?.data?.data?.assignedUsers]
                }
              }else{
                const filteredAssignedTo = action?.payload?.data?.data?.assignedUsers.filter((item: any) => action?.meta?.arg?.filters?.assignedTo.includes(item.id));
                // set assignedTo as selected assignedTo array
                state.projectOverviewData = {
                  ...state.projectOverviewData,
                  filters: {
                    assignedTo: filteredAssignedTo?.length === action?.payload?.data?.data?.assignedUsers?.length? [allOption, ...action?.payload?.data?.data?.assignedUsers]: filteredAssignedTo
                  },
                  assignedUsers: [allOption, ...action?.payload?.data?.data?.assignedUsers]
                }
              }

            }else{
              state.success = null;
              state.projectOverviewData = null;
              state.error = 'Projects overview details could not be fetched.';
            }
      })
      .addCase(pmProjectsAction.getProjectOverviewDetailsAction.rejected, (state, action:any) => {
            state.loading = false;
            state.success = null;
            state.projectOverviewData = null;
            state.error = action?.payload?.data?.message ?? 'Projects overview details could not be fetched.';
      })

      // -------- cases of project center invoice update api data -------
      .addCase(pmProjectsAction.updateInvoiceAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(pmProjectsAction.updateInvoiceAction.fulfilled, (state, action) => {
        state.loading = false;
        if(action?.payload?.data?.status===200){
          state.error = null;
          state.success = action?.payload?.data?.message;
          state.projectInvoicesList = action?.payload?.data?.data;
        }else{
          state.success = null;
          state.error = 'Projects invoice could not be updated.';
        }
      })
      .addCase(pmProjectsAction.updateInvoiceAction.rejected, (state, action:any) => {
        state.loading = false;
        state.success = null;
        state.releaseProjectInvoiceData = null;
        state.error = action?.payload?.data?.message ?? 'Projects invoice could not be updated.';
      })

      // -------- cases of project timeline list api data -------
      .addCase(pmProjectsAction.getProjectTimelineListAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        // set this as null only when user is not fetching this data while updating project tasks
        if(!action?.meta?.arg?.hideLoader){
          state.projectTimelineList = [];
        }
      })
      .addCase(pmProjectsAction.getProjectTimelineListAction.fulfilled, (state, action) => {
            state.loading = false;
            if(action?.payload?.data?.status===200){
              state.error = null;
              state.success = action?.payload?.data?.message;
              state.projectTimelineList = action?.payload?.data?.data?.map((item:any, index:number)=>{
                return {
                  ...item,
                  menuPosition: action?.payload?.data?.data?.length<4 || action?.payload?.data?.data?.length-index>3?true:false,
                }
              });
            }else{
              state.success = null;
              state.projectTimelineList = [];
              state.error = 'Projects timeline list could not be fetched.';
            }
      })
      .addCase(pmProjectsAction.getProjectTimelineListAction.rejected, (state, action:any) => {
            state.loading = false;
            state.success = null;
            state.projectTimelineList = [];
            state.error = action?.payload?.data?.message ?? 'Projects timeline list could not be fetched.';
      })

      // -------- cases of project timeline task start dateupdate api data -------
      .addCase(pmProjectsAction.inlineUpdateProjectTaskAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        // set this as null only when user is not fetching this data while updating project tasks
        if(!action?.meta?.arg?.hideLoader){
          state.projectTimelineList = [];
        }
      })
      .addCase(pmProjectsAction.inlineUpdateProjectTaskAction.fulfilled, (state, action) => {
            state.loading = false;
            if(action?.payload?.data?.status===200){
              state.error = null;
              state.success = action?.payload?.data?.message;
              state.projectTimelineList = action?.payload?.data?.data?.map((item:any, index:number)=>{
                return {
                  ...item,
                  menuPosition: action?.payload?.data?.data?.length<4 || action?.payload?.data?.data?.length-index>3?true:false,
                }
              });
            }else{
              state.success = null;
              state.projectTimelineList = [];
              state.error = 'Projects timeline list could not be fetched.';
            }
      })
      .addCase(pmProjectsAction.inlineUpdateProjectTaskAction.rejected, (state, action:any) => {
            state.loading = false;
            state.success = null;
            state.projectTimelineList = [];
            state.error = action?.payload?.data?.message ?? 'Projects timeline list could not be fetched.';
      })

      // -------- cases of task connections updated api data -------
      .addCase(pmProjectsAction.updateTaskConnectionAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(pmProjectsAction.updateTaskConnectionAction.fulfilled, (state, action) => {
        state.loading = false;
        if(action?.payload?.data?.status===200){
          state.error = null;
          state.success = action?.payload?.data?.message;
          state.updateTaskConnections = action?.payload?.data?.data;
        }else{
          state.success = null;
          state.updateTaskConnections = null;
          state.error = 'Task connections could not be updated.';
        }
      })
      .addCase(pmProjectsAction.updateTaskConnectionAction.rejected, (state, action:any) => {
        state.loading = false;
        state.success = null;
        state.updateTaskConnections = null;
        state.error = action?.payload?.data?.message ?? 'Task connections could not be updated.';
      })

      // -------- cases of project phase tasks list api data -------
      .addCase(pmProjectsAction.getProjectTasksListAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        // set this as null only when user is not fetching this data while updating project tasks
        if(!action?.meta?.arg?.hideLoader){
          state.projectPhaseTasksList = [];
        }
      })
      .addCase(pmProjectsAction.getProjectTasksListAction.fulfilled, (state, action) => {
            state.loading = false;
            if(action?.payload?.data?.status===200){
              state.error = null;
              state.success = action?.payload?.data?.message;
              state.projectPhaseTasksList = action?.payload?.data?.data?.map((task:any) => {
                return {
                  ...task,
                  label: task?.name
                }
              });
            }else{
              state.success = null;
              state.projectPhaseTasksList = [];
              state.error = 'Projects phase-wise tasks list could not be fetched.';
            }
      })
      .addCase(pmProjectsAction.getProjectTasksListAction.rejected, (state, action:any) => {
            state.loading = false;
            state.success = null;
            state.projectPhaseTasksList = [];
            state.error = action?.payload?.data?.message ?? 'Projects phase-wise tasks list could not be fetched.';
      })

      // -------- cases of project overview task details api data -------
      .addCase(pmProjectsAction.getProjectOverviewTaskDetailsAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        if(!action?.meta?.arg?.hideLoader){
          state.projectOverviewTaskData = null;
        }
      })
      .addCase(pmProjectsAction.getProjectOverviewTaskDetailsAction.fulfilled, (state, action) => {
            state.loading = false;
            if(action?.payload?.data?.status===200){
              state.error = null;
              state.success = action?.payload?.data?.message;
              state.projectOverviewTaskData = action?.payload?.data?.data;
            }else{
              state.success = null;
              state.projectOverviewTaskData = null;
              state.error = 'Projects task details could not be fetched.';
            }
      })
      .addCase(pmProjectsAction.getProjectOverviewTaskDetailsAction.rejected, (state, action:any) => {
            state.loading = false;
            state.success = null;
            state.projectOverviewTaskData = null;
            state.error = action?.payload?.data?.message ?? 'Projects task details could not be fetched.';
      })

      // -------- cases of project phases api data -------
      .addCase(pmProjectsAction.getProjectPhasesAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.projectPhases = [];
      })
      .addCase(pmProjectsAction.getProjectPhasesAction.fulfilled, (state, action) => {
            state.loading = false;
            if(action?.payload?.data?.status===200){
              state.error = null;
              state.success = action?.payload?.data?.message;
              state.projectPhases = action?.payload?.data?.data;
            }else{
              state.success = null;
              state.projectPhases = [];
              state.error = 'Projects phases could not be fetched.';
            }
      })
      .addCase(pmProjectsAction.getProjectPhasesAction.rejected, (state, action:any) => {
            state.loading = false;
            state.success = null;
            state.projectPhases = [];
            state.error = action?.payload?.data?.message ?? 'Projects phases could not be fetched.';
      })

      // -------- cases of add project task api data -------
      .addCase(pmProjectsAction.addProjectTaskAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.projectOverviewAddTask = null;
      })
      .addCase(pmProjectsAction.addProjectTaskAction.fulfilled, (state, action) => {
            state.loading = false;
            if(action?.payload?.data?.status===200){
              state.error = null;
              state.success = action?.payload?.data?.message;
              state.projectOverviewAddTask = action?.payload?.data?.data;
            }else{
              state.success = null;
              state.projectOverviewAddTask = null;
              state.error = 'Projects task could not be added.';
            }
      })
      .addCase(pmProjectsAction.addProjectTaskAction.rejected, (state, action:any) => {
            state.loading = false;
            state.success = null;
            state.projectOverviewAddTask = null;
            state.error = action?.payload?.data?.message ?? 'Projects task could not be added.';
      })

      // -------- cases of update project task api data -------
      .addCase(pmProjectsAction.updateProjectTaskAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.projectOverviewUpdateTask = null;
      })
      .addCase(pmProjectsAction.updateProjectTaskAction.fulfilled, (state, action) => {
            state.loading = false;
            if(action?.payload?.data?.status===200){
              state.error = null;
              state.success = action?.payload?.data?.message;
              state.projectOverviewUpdateTask = action?.payload?.data?.data;
            }else{
              state.success = null;
              state.projectOverviewUpdateTask = null;
              state.error = 'Projects task could not be updated.';
            }
      })
      .addCase(pmProjectsAction.updateProjectTaskAction.rejected, (state, action:any) => {
            state.loading = false;
            state.success = null;
            state.projectOverviewUpdateTask = null;
            state.error = action?.payload?.data?.message ?? 'Projects task could not be updated.';
      })

      // -------- cases of delete project task api data -------
      .addCase(pmProjectsAction.deleteProjectTaskAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.projectOverviewDeleteTask = null;
      })
      .addCase(pmProjectsAction.deleteProjectTaskAction.fulfilled, (state, action) => {
            state.loading = false;
            if(action?.payload?.data?.status===200){
              state.error = null;
              state.success = action?.payload?.data?.message;
              state.projectOverviewDeleteTask = action?.payload?.data?.data;
            }else{
              state.success = null;
              state.projectOverviewDeleteTask = null;
              state.error = 'Projects task could not be deleted.';
            }
      })
      .addCase(pmProjectsAction.deleteProjectTaskAction.rejected, (state, action:any) => {
            state.loading = false;
            state.success = null;
            state.projectOverviewDeleteTask = null;
            state.error = action?.payload?.data?.message ?? 'Projects task could not be deleted.';
      })

      // -------- get Change Order -------
      .addCase(pmProjectsAction.getChangeOrderAction.pending, (state, action) => {
        state.error = "";
        state.projectChangeOrderList = [];
      })
      .addCase(pmProjectsAction.getChangeOrderAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status===200) {
          state.projectChangeOrderList= action?.payload?.data?.data;
          state.error = "";
        } else {
          state.error = "Failed to fetch change orders.";
        }
      })
      .addCase(pmProjectsAction.getChangeOrderAction.rejected, (state, action:any) => {
        state.projectChangeOrderList = [];
        state.error = action?.payload?.data?.message || "Failed to fetch change orders.";
      })

      // -------- get Change Order items -------
      .addCase(pmProjectsAction.getChangeOrderItemsAction.pending, (state, action) => {
        state.error = "";
        state.projectChangeOrderItems = [];
      })
      .addCase(pmProjectsAction.getChangeOrderItemsAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status===200) {
          state.projectChangeOrderItems= action?.payload?.data?.data;
          state.error = "";
        } else {
          state.error = "Failed to fetch change orders items.";
        }
      })
      .addCase(pmProjectsAction.getChangeOrderItemsAction.rejected, (state, action:any) => {
        state.projectChangeOrderItems = [];
        state.error = action?.payload?.data?.message || "Failed to fetch change orders items.";
      })

      // -------- create Change Order -------
      .addCase(pmProjectsAction.createChangeOrderAction.pending, (state, action) => {
        state.error = "";
        state.createChangeOrder = null;
      })
      .addCase(pmProjectsAction.createChangeOrderAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status===200) {
          state.createChangeOrder= action?.payload?.data?.data;
          state.error = "";
        } else {
          state.error = "Failed to create change order.";
        }
      })
      .addCase(pmProjectsAction.createChangeOrderAction.rejected, (state, action:any) => {
        state.createChangeOrder = null;
        state.error = action?.payload?.data?.message || "Failed to create change order.";
      })

      // -------- save Change Order -------
      .addCase(pmProjectsAction.saveChangeOrderAction.pending, (state, action) => {
        state.error = "";
        // state.createChangeOrder = null;
      })
      .addCase(pmProjectsAction.saveChangeOrderAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status===200) {
          // state.createChangeOrder= action?.payload?.data?.data;
          state.error = "";
        } else {
          state.error = "Failed to save change order.";
        }
      })
      .addCase(pmProjectsAction.saveChangeOrderAction.rejected, (state, action:any) => {
        // state.createChangeOrder = null;
        state.error = action?.payload?.data?.message || "Failed to save change order.";
      })

      // -------- get Change Order Details -------
      .addCase(pmProjectsAction.getChangeOrderDetailsAction.pending, (state, action) => {
        state.error = "";
        state.changeOrderDetails = null;
      })
      .addCase(pmProjectsAction.getChangeOrderDetailsAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status===200) {
          state.changeOrderDetails= action?.payload?.data?.data;
          state.error = "";
        } else {
          state.error = "Failed to get change order details.";
        }
      })
      .addCase(pmProjectsAction.getChangeOrderDetailsAction.rejected, (state, action:any) => {
        state.changeOrderDetails = null;
        state.error = action?.payload?.data?.message || "Failed to get change order details.";
      })

      // -------- get Change Order terms -------
      .addCase(pmProjectsAction.getChangeOrderTermsAction.pending, (state, action) => {
        state.error = "";
        state.changeOrderTerms = null;
      })
      .addCase(pmProjectsAction.getChangeOrderTermsAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status===200) {
          state.changeOrderTerms= action?.payload?.data?.data;
          state.error = "";
        } else {
          state.error = "Failed to get change order terms.";
        }
      })
      .addCase(pmProjectsAction.getChangeOrderTermsAction.rejected, (state, action:any) => {
        state.changeOrderTerms = null;
        state.error = action?.payload?.data?.message || "Failed to get change order terms.";
      })

      // -------- save Change Order notes -------
      .addCase(pmProjectsAction.saveChangeOrderNotesAction.pending, (state, action) => {
        state.error = "";
        state.savedChangeOrderNotes = null;
      })
      .addCase(pmProjectsAction.saveChangeOrderNotesAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status===200) {
          state.savedChangeOrderNotes= action?.payload?.data?.data;
          state.error = "";
        } else {
          state.error = "Failed to save change order notes.";
        }
      })
      .addCase(pmProjectsAction.saveChangeOrderNotesAction.rejected, (state, action:any) => {
        state.savedChangeOrderNotes = null;
        state.error = action?.payload?.data?.message || "Failed to save change order notes.";
      })

      // -------- save Change Order Intro -------
      .addCase(pmProjectsAction.saveChangeOrderIntroAction.pending, (state, action) => {
        state.error = "";
        // state.changeOrderTerms = null;
      })
      .addCase(pmProjectsAction.saveChangeOrderIntroAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status===200) {
          // state.changeOrderTerms= action?.payload?.data?.data;
          state.error = "";
        } else {
          state.error = "Failed to save change order intro.";
        }
      })
      .addCase(pmProjectsAction.saveChangeOrderIntroAction.rejected, (state, action:any) => {
        // state.changeOrderTerms = null;
        state.error = action?.payload?.data?.message || "Failed to save change order intro.";
      })

      // -------- upload Change Order pdf -------
      .addCase(pmProjectsAction.uploadChangeOrderPdfAction.pending, (state, action) => {
        state.changeOrderUploadSuccess = false;
        state.error = "";
      })
      .addCase(pmProjectsAction.uploadChangeOrderPdfAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status===200) {
          state.changeOrderUploadSuccess = true;
          state.error = "";
        } else {
          state.changeOrderUploadSuccess = false;
          state.error = "Failed to upload change order pdf.";
        }
      })
      .addCase(pmProjectsAction.uploadChangeOrderPdfAction.rejected, (state, action:any) => {
        state.changeOrderUploadSuccess = false;
        state.error = action?.payload?.data?.message || "Failed to upload change order pdf.";
      })

      // -------- get uploaded document list -------
      .addCase(pmProjectsAction.changeOrderAttachmentListAction.pending, (state, action) => {
        state.error = "";
        state.changeOrderAttachmentList = null;
      })
      .addCase(pmProjectsAction.changeOrderAttachmentListAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status===200) {
          state.changeOrderAttachmentList= action?.payload?.data?.data;
          state.error = "";
        } else {
          state.error = "Failed to get uploaded document list.";
        }
      })
      .addCase(pmProjectsAction.changeOrderAttachmentListAction.rejected, (state, action:any) => {
        state.changeOrderAttachmentList = null;
        state.error = action?.payload?.data?.message || "Failed to get uploaded document list.";
      })

      // -------- remove uploaded attachment -------
      .addCase(pmProjectsAction.removeChangeOrderAttachmentAction.pending, (state, action) => {
        state.changeOrderRemoveSuccess = false;
        state.error = "";
      })
      .addCase(pmProjectsAction.removeChangeOrderAttachmentAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status===200) {
          state.changeOrderRemoveSuccess = true;
          state.error = "";
        } else {
          state.changeOrderRemoveSuccess = false;
          state.error = "Failed to remove uploaded attachment.";
        }
      })
      .addCase(pmProjectsAction.removeChangeOrderAttachmentAction.rejected, (state, action:any) => {
        state.changeOrderRemoveSuccess = false;
        state.error = action?.payload?.data?.message || "Failed to remove uploaded attachment.";
      })

      // -------- export change order -------
      .addCase(pmProjectsAction.exportChangeOrderAction.pending, (state, action) => {
        state.changeOrderRelease = false;
        state.error = "";
      })
      .addCase(pmProjectsAction.exportChangeOrderAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status===200) {
          state.changeOrderRelease = true;
          state.error = "";
        } else {
          state.changeOrderRelease = false;
          state.error = "Failed to export change order.";
        }
      })
      .addCase(pmProjectsAction.exportChangeOrderAction.rejected, (state, action:any) => {
        state.changeOrderRelease = false;
        state.error = action?.payload?.data?.message || "Failed to export change order.";
      })

      // -------- delete change order -------
      .addCase(pmProjectsAction.deleteChangeOrderAction.pending, (state, action) => {
        state.changeOrderDelete = null;
        state.error = "";
      })
      .addCase(pmProjectsAction.deleteChangeOrderAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status===200) {
          state.changeOrderDelete = action?.payload?.data?.data;
          state.error = "";
        } else {
          state.changeOrderDelete = null;
          state.error = "Failed to delete change order.";
        }
      })
      .addCase(pmProjectsAction.deleteChangeOrderAction.rejected, (state, action:any) => {
        state.changeOrderDelete = null;
        state.error = action?.payload?.data?.message || "Failed to delete change order.";
      })

      // -------- duplicate change order -------
      .addCase(pmProjectsAction.duplicateChangeOrderAction.pending, (state, action) => {
        state.changeOrderDuplicate = null;
        state.error = "";
      })
      .addCase(pmProjectsAction.duplicateChangeOrderAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status===200) {
          state.changeOrderDuplicate = action?.payload?.data?.data;
          state.error = "";
        } else {
          state.changeOrderDuplicate = null;
          state.error = "Failed to create duplicate change order.";
        }
      })
      .addCase(pmProjectsAction.duplicateChangeOrderAction.rejected, (state, action:any) => {
        state.changeOrderDuplicate = null;
        state.error = action?.payload?.data?.message || "Failed to create duplicate change order.";
      })

      // get payment schedule
      .addCase(pmProjectsAction.getCOPaymentScheduleAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.coPaymentSchedule = [];
      })
      .addCase(pmProjectsAction.getCOPaymentScheduleAction.fulfilled, (state, action) => {
        state.loading = false;
        if(action?.payload?.data?.status===200){
          state.coPaymentSchedule = action.payload.data.data;
          state.success = action.payload.data.data;
        }else{
          state.success = null;
          state.coPaymentSchedule = [];
          state.error = action?.payload?.data ?? 'Get Payment Failed';
        }
      })
      .addCase(pmProjectsAction.getCOPaymentScheduleAction.rejected, (state, action:any) => {
        state.loading = false;
        state.success = null;
        state.coPaymentSchedule = [];
        state.error = action?.payload?.data ?? 'Get Payment Failed';
      })

      // -------- rfp list -------
      .addCase(pmProjectsAction.rfpListAction.pending, (state, action) => {
        state.rfpList = null;
        state.error = "";
      })
      .addCase(pmProjectsAction.rfpListAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status === 200) {
          state.rfpList = action?.payload?.data?.data;
          state.error = "";
        } else {
          state.rfpList = null;
          state.error = "Failed to fetch rfp list.";
        }
      })
      .addCase(pmProjectsAction.rfpListAction.rejected, (state, action: any) => {
        state.rfpList = null;
        state.error = action?.payload?.data?.message || "Failed to fetch rfp list.";
      })

      // -------- create rfp -------
      .addCase(pmProjectsAction.createRfpAction.pending, (state, action) => {
        // state.rfpList = null;
        state.error = "";
      })
      .addCase(pmProjectsAction.createRfpAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status === 200) {
          // state.rfpList = action?.payload?.data?.data;
          state.error = "";
        } else {
          // state.rfpList = null;
          state.error = "Failed to create rfp.";
        }
      })
      .addCase(pmProjectsAction.createRfpAction.rejected, (state, action: any) => {
        // state.rfpList = null;
        state.error = action?.payload?.data?.message || "Failed to create rfp.";
      })

      // -------- update rfp -------
      .addCase(pmProjectsAction.updateRfpAction.pending, (state, action) => {
        // state.rfpList = null;
        state.error = "";
      })
      .addCase(pmProjectsAction.updateRfpAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status === 200) {
          // state.rfpList = action?.payload?.data?.data;
          state.error = "";
        } else {
          // state.rfpList = null;
          state.error = "Failed to update rfp.";
        }
      })
      .addCase(pmProjectsAction.updateRfpAction.rejected, (state, action: any) => {
        // state.rfpList = null;
        state.error = action?.payload?.data?.message || "Failed to update rfp.";
      })

      // -------- unrelease change order -------
      .addCase(pmProjectsAction.unreleaseChangeOrderAction.pending, (state, action) => {
        state.error = "";
      })
      .addCase(pmProjectsAction.unreleaseChangeOrderAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status === 200) {
          state.error = "";
        } else {
          state.error = "Failed to unrelease change order.";
        }
      })
      .addCase(pmProjectsAction.unreleaseChangeOrderAction.rejected, (state, action: any) => {
        state.error = action?.payload?.data?.message || "Failed to unrelease change order.";
      })

      // -------- rearrange overview list -------
      .addCase(pmProjectsAction.rearrangeOverviewListAction.pending, (state, action) => {
        state.error = "";
      })
      .addCase(pmProjectsAction.rearrangeOverviewListAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status === 200) {
          state.error = "";
        } else {
          state.error = "Failed to rearrange overview list.";
        }
      })
      .addCase(pmProjectsAction.rearrangeOverviewListAction.rejected, (state, action: any) => {
        state.error = action?.payload?.data?.message || "Failed to rearrange overview list.";
      })

      // -------- generate zip -------
      .addCase(pmProjectsAction.generateZipAction.pending, (state, action) => {
        state.error = "";
      })
      .addCase(pmProjectsAction.generateZipAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status === 200) {
          state.error = "";
        } else {
          state.error = "Failed to generate zip.";
        }
      })
      .addCase(pmProjectsAction.generateZipAction.rejected, (state, action: any) => {
        state.error = action?.payload?.data?.message || "Failed to generate zip.";
      })

      // -------- cases of project center rfqs list api data -------
      .addCase(pmProjectsAction.getProjectRfqsAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.projectRfqsList = [];
      })
      .addCase(pmProjectsAction.getProjectRfqsAction.fulfilled, (state, action) => {
            state.loading = false;
            if(action?.payload?.data?.status===200){
              state.error = null;
              state.success = action?.payload?.data?.message;
              state.projectRfqsList = action?.payload?.data?.data;
            }else{
              state.success = null;
              state.projectRfqsList = [];
              state.error = 'Projects invoices could not be fetched.';
            }
      })
      .addCase(pmProjectsAction.getProjectRfqsAction.rejected, (state, action:any) => {
            state.loading = false;
            state.success = null;
            state.projectRfqsList = [];
            state.error = action?.payload?.data?.message ?? 'Projects invoices could not be fetched.';
      })

      // -------- rfq details -------
      .addCase(pmProjectsAction.getRfqsDetailsAction.pending, (state,) => {
        state.rfqsDetails = null;
        state.error = "";
      })
      .addCase(pmProjectsAction.getRfqsDetailsAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status === 200) {
          state.rfqsDetails = action?.payload?.data?.data;
          state.error = "";
        } else {
          state.error = "Failed to fetch rfq details.";
        }
      })
      .addCase(pmProjectsAction.getRfqsDetailsAction.rejected, (state, action: any) => {
        state.rfqsDetails = null;
        state.error = action?.payload?.data?.message || "Failed to fetch rfq details.";
      })

      // ------- attachment deletion --------------
      .addCase(pmProjectsAction.deleteDocumentMediaFilesAction.pending, (state,) => {
        state.error = "";
      })
      .addCase(pmProjectsAction.deleteDocumentMediaFilesAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status === 200) {
          state.rfqsDetails.attachments = action.payload.data.data;
          state.error = "";
        } else {
          state.error = "Failed to delete attachment.";
        }
      })
      .addCase(pmProjectsAction.deleteDocumentMediaFilesAction.rejected, (state, action: any) => {
        state.rfqsDetails = null;
        state.error = action?.payload?.data?.message || "Failed to delete attachment.";
      })

      // ------- attachment reorder --------------
      .addCase(pmProjectsAction.updateDocumentOrderAction.pending, (state,) => {
        state.error = "";
      })
      .addCase(pmProjectsAction.updateDocumentOrderAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status === 200) {
            // Merge the updated attachments data while maintaining the structure of rfqsDetails
            state.rfqsDetails = {
                ...state.rfqsDetails,
                attachments: [...action.payload.data.data], // Ensure attachments are updated with the new data
            };
            state.error = ""; 
        } else {
            state.error = "Failed to update attachment order."; 
        }
      })
      .addCase(pmProjectsAction.updateDocumentOrderAction.rejected, (state, action: any) => {
        state.rfqsDetails = null;
        state.error = action?.payload?.data?.message || "Failed to fetch attachment order.";
      })

      // ------- Rfqs Details Updatation --------------
      .addCase(pmProjectsAction.updateProjectRfqAction.pending, (state,) => {
        state.error = "";
      })
      .addCase(pmProjectsAction.updateProjectRfqAction.fulfilled, (state, action) => {
      if (action?.payload?.data?.status === 200) {
        state.rfqsDetails = action.payload.data.data;
        state.error = "";
      } else {
        state.error = "Failed to fetch rfqs details.";
      }
    })
    .addCase(pmProjectsAction.updateProjectRfqAction.rejected, (state, action: any) => {
      state.error = action?.payload?.data?.message || "Failed to fetch rfq details.";
    })

    // -------------------------- PO List Slice ----------------------
    .addCase(pmProjectsAction.getPurchaseOrderListAction.pending, (state, action) => {
        state.error = "";
    })
    .addCase(pmProjectsAction.getPurchaseOrderListAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status === 200) {
          state.poList = action?.payload?.data?.data;
          state.error = "";
        } else {
          state.error = "Failed to fetch purchase orders.";
        }
      })
    .addCase(pmProjectsAction.getPurchaseOrderListAction.rejected, (state, action: any) => {
        state.poList = [];
        state.error = action?.payload?.data?.message || "Failed to fetch purchase orders.";
    })

    // -------------------------- PO Review Slice ----------------------
    .addCase(pmProjectsAction.poReviewAction.pending, (state, action) => {
      state.error = "";
    })
    .addCase(pmProjectsAction.poReviewAction.fulfilled, (state, action) => {
      if (action?.payload?.data?.status === 200) {
        state.poReview = action?.payload?.data?.data;
        state.error = "";
      } else {
        state.error = "Failed to fetch purchase order review.";
      }
    })
    .addCase(pmProjectsAction.poReviewAction.rejected, (state, action: any) => {
      state.error = action?.payload?.data?.message || "Failed to fetch purchase order review.";
    })

    
    //------------------------------ PO Details Slice --------------------
    .addCase(pmProjectsAction.purchaseOrderDetailsAction.pending, (state) => {
        state.error = "";
    })
    .addCase(pmProjectsAction.purchaseOrderDetailsAction.fulfilled, (state, action) =>{
      if (action?.payload?.data?.status === 200) {
        state.poDetails = action?.payload?.data?.data;
        state.error = "";
      } else {
        state.error = "Failed to fetch purchase order details.";
      }
    })
    .addCase(pmProjectsAction.purchaseOrderDetailsAction.rejected, (state, action: any) => {
        state.poPaymentSchedule = null;
        state.error = action?.payload?.data?.message || "Failed to fetch purchase order details.";
      })

    // ----------------------------- PO Attachments Order Slice ---------------------------------
      .addCase(pmProjectsAction.changePOAttachementSequenceAction.pending, (state,) => {
        state.error = "";
      })
      .addCase(pmProjectsAction.changePOAttachementSequenceAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status === 200) {
            // Merge the updated attachments data while maintaining the structure of rfqsDetails
            state.poDetails = {
                ...state.poDetails,
                attachments: [...action.payload.data.data], // Ensure attachments are updated with the new data
            };
            state.error = ""; 
        } else {
            state.error = "Failed to update attachment order."; 
        }
      })
      .addCase(pmProjectsAction.changePOAttachementSequenceAction.rejected, (state, action: any) => {
        state.poDetails = null;
        state.error = action?.payload?.data?.message || "Failed to fetch attachment order.";
      })

    // ----------------------------- GET PO Payment Schdule Slice ---------------------------------
    .addCase(pmProjectsAction.getPOPaymentScheduleAction.pending, (state) => {
      state.error = true;
    })

    .addCase(pmProjectsAction.getPOPaymentScheduleAction.fulfilled, (state, action) => {
      if (action?.payload?.data?.status === 200) {
        state.poPaymentSchedule = action?.payload?.data?.data;
        state.error = "";
      } else {
        state.error = "Failed to fetch purchase order payment schedule.";
      }
    })
    .addCase(pmProjectsAction.getPOPaymentScheduleAction.rejected, (state, action: any) => {
      state.poPaymentSchedule = null;
      state.error = action?.payload?.data?.message || "Failed to fetch purchase order payment schedule.";
    })

    // ---------------------------- Save Payment Schedule -------------------------------------------
    .addCase(pmProjectsAction.savePOPaymentScheduleAction.pending, (state) =>{
        state.loading = true;
        state.error = null;
        state.success = null;   
    })
    .addCase(pmProjectsAction.savePOPaymentScheduleAction.fulfilled, (state, action) => {
        state.loading = false;
        if(action?.payload?.data?.status ===200){
          state.savedPOPaymentSchedule = action.payload.data;
          state.success = action?.payload
        }else{
          state.success = null;
          state.error = action?.payload?.data ?? 'Save Payment Failed';
        }
    })
    .addCase(pmProjectsAction.savePOPaymentScheduleAction.rejected, (state, action:any) => {
        state.loading = false;
        state.success = null;
        state.error = action?.payload?.data ?? 'Save Payment Failed';
      })

      // --------------------------- Update PO Details Slice ---------------------------------
    .addCase(pmProjectsAction.updatePODetailsAction.pending, (state,) => {
      state.error = "";
    })
    .addCase(pmProjectsAction.updatePODetailsAction.fulfilled, (state, action) => {
      if (action?.payload?.data?.status === 200) {
        state.poDetails = action.payload.data.data;
        state.error = "";
      } else {
        state.error = "Failed to fetch purchase order details.";
      }
    })
    .addCase(pmProjectsAction.updatePODetailsAction.rejected, (state, action: any) => {
      state.poDetails = null;
      state.error = action?.payload?.data?.message || "Failed to fetch purchase order details.";
    })

    // -------------------------- Accepted RFQ Bids List Slice ----------------------
    .addCase(pmProjectsAction.getAcceptedRfqBidsListingAction.pending, (state, action) => {
        state.error = "";
    })
    .addCase(pmProjectsAction.getAcceptedRfqBidsListingAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status === 200) {
          state.acceptedRfqBidsList = action?.payload?.data?.data;
          state.error = "";
        } else {
          state.error = "Failed to fetch purchase orders.";
        }
      })
    .addCase(pmProjectsAction.getAcceptedRfqBidsListingAction.rejected, (state, action: any) => {
        state.acceptedRfqBidsList = [];
        state.error = action?.payload?.data?.message || "Failed to fetch purchase orders.";
    })


    // --------------------------- Expenses List Slice ----------------------
    .addCase(pmProjectsAction.getProjectExpenseAction.pending, (state, action) => {
        state.error = "";
        state.loading = true;
        state.projectExpensesList = [];
    })
    .addCase(pmProjectsAction.getProjectExpenseAction.fulfilled, (state, action) => {
      if (action?.payload?.data?.status === 200) {
          state.projectExpensesList = action?.payload?.data?.data;
          state.loading = false;
        } else {
          state.error = "Failed to fetch purchase orders Expenses List.";
        }
      })
    .addCase(pmProjectsAction.getProjectExpenseAction.rejected, (state, action: any) => {
        state.loading = false; 
        state.projectExpensesList = [];
        state.error = action?.payload?.data?.message || "Failed to fetch Expenses List.";
    })

    // -------------------------- Get Payment Review Slice -----------------------
    .addCase(pmProjectsAction.getExpensesPaymentReviewAction.pending, (state) => {
      state.error = "";
    })
    .addCase(pmProjectsAction.getExpensesPaymentReviewAction.fulfilled, (state, action) => {
      if (action?.payload?.data?.status === 200) {
        state.expensesPaymentReview = action?.payload?.data?.data;
      } else {
        state.error = "Failed to fetch purchase orders.";
      }
    })
    .addCase(pmProjectsAction.getExpensesPaymentReviewAction.rejected, (state, action: any) => {
      state.error = action?.payload?.data?.message || "Failed to fetch Payment Review orders.";
    })

    // ------------------------- Update Expenses Slice ----------------------------
    .addCase(pmProjectsAction.updateExpenseAction.pending, (state) => {
      state.error = "";
    })
    .addCase(pmProjectsAction.updateExpenseAction.fulfilled, (state, action) => {
      if (action?.payload?.data?.status === 200) {
        state.projectExpensesList = action?.payload?.data?.data;
        state.error = "";
      } else {
        state.error = "Failed to fetch purchase orders.";
      }
    })
    .addCase(pmProjectsAction.updateExpenseAction.rejected, (state, action: any) => {
      state.error = action?.payload?.data?.message || "Failed to Update Expenses.";
    })

    // -------------------------- Cases of Get Expenses Notes Categories ----------------
    .addCase(pmProjectsAction.getExpenseNotesAction.pending, (state) => {
      state.error = "";
      state.expenseNotes = []
    })
    .addCase(pmProjectsAction.getExpenseNotesAction.fulfilled, (state, action) => {
      if (action?.payload?.data?.status === 200) {
        state.expenseNotes = action?.payload?.data?.data;
        state.error = "";
      } else {
        state.error = "Failed to fetch expenses notes.";
      }
    })
    .addCase(pmProjectsAction.getExpenseNotesAction.rejected, (state, action: any) => {
      state.expenseNotes = [];
      state.error = action?.payload?.data?.message || "Failed to fetch expenses notes.";
    })

    // --------------------------- Expenses List Slice ----------------------
    .addCase(fmProjectsAction.getProjectExpensesListAction.fulfilled, (state, action) => {
      // Update only 'subcontractorTotalExp' and 'vendorTotalExp' in projectExpensesList, keep the rest, and only if present
      const { subcontractorTotalExp, vendorTotalExp } = action?.payload?.data?.data || {};
      state.projectExpensesList = {
        ...state.projectExpensesList,
        ...(subcontractorTotalExp !== undefined ? { subcontractorTotalExp } : {}),
        ...(vendorTotalExp !== undefined ? { vendorTotalExp } : {})
      };
    })
    .addCase(fmProjectsAction.updateProjectEstimatedExpenseAction.fulfilled, (state, action) => {
      // Update only 'subcontractorTotalExp' and 'vendorTotalExp' in projectExpensesList, keep the rest, and only if present
      const { subcontractorTotalExp, vendorTotalExp } = action?.payload?.data?.data || {};
      state.projectExpensesList = {
        ...state.projectExpensesList,
        ...(subcontractorTotalExp !== undefined ? { subcontractorTotalExp } : {}),
        ...(vendorTotalExp !== undefined ? { vendorTotalExp } : {})
      };
    })
    .addCase(fmProjectsAction.addProjectEstimatedExpenseAction.fulfilled, (state, action) => {
      // Update only 'subcontractorTotalExp' and 'vendorTotalExp' in projectExpensesList, keep the rest, and only if present
      const { subcontractorTotalExp, vendorTotalExp } = action?.payload?.data?.data || {};
      state.projectExpensesList = {
        ...state.projectExpensesList,
        ...(subcontractorTotalExp !== undefined ? { subcontractorTotalExp } : {}),
        ...(vendorTotalExp !== undefined ? { vendorTotalExp } : {})
      };
    })

    // -------- cases of global rfq attachments api data -------
    .addCase(pmProjectsAction.getGlobalRfqAttachmentsAction.pending, (state, action) => {
      state.loading = true;
      state.error = null;
      state.success = null;
      state.globalRfqAttachments = [];
    })
    .addCase(pmProjectsAction.getGlobalRfqAttachmentsAction.fulfilled, (state, action) => {
          state.loading = false;
          if(action?.payload?.data?.status===200){
            state.error = null;
            state.success = action?.payload?.data?.message;
            state.globalRfqAttachments = action?.payload?.data?.data;
          }else{
            state.success = null;
            state.globalRfqAttachments = [];
            state.error = 'Global RFQ attachments could not be fetched.';
          }
    })
    .addCase(pmProjectsAction.getGlobalRfqAttachmentsAction.rejected, (state, action:any) => {
          state.loading = false;
          state.success = null;
          state.globalRfqAttachments = [];
          state.error = action?.payload?.data?.message ?? 'Global RFQ attachments could not be fetched.';

    })

    
    // projects Autocomplete
    .addCase(pmProjectsAction.projectAutocompleteAction.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.projectAutocomplete= []
    })
    .addCase(pmProjectsAction.projectAutocompleteAction.fulfilled, (state, action) => {
      state.loading = false;
      if(action?.payload?.data?.status===200){
        state.projectAutocomplete = action?.payload?.data;
      }else{
        state.projectAutocomplete= [];
        state.error = action?.payload?.data?.message ?? 'Failed to fetch proposals';  
      }
    })
    .addCase(pmProjectsAction.projectAutocompleteAction.rejected, (state, action:any) => {
      state.loading = false;
      state.projectAutocomplete= [];
      state.error = action?.payload?.data ?? 'Failed to fetch proposals';
    })

    },
});

export const { cleanChangeOrder, cleanCameraList, setProjectTimelineList } = pmProjectsSlice.actions;
export default pmProjectsSlice.reducer;